import { TextInput } from "../text-input/TextInput.js";
import { jsx } from "react/jsx-runtime";
import { z } from "zod";

//#region src/components/inputs/phone-number/PhoneNumberInput.tsx
const phoneNumberSchema = z.string().refine((val) => /^\d{10}$/.test(val)).transform((val) => `(${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6)}`);
const PHONE_PLACEHOLDER = "(000) 000-0000";
const PhoneNumberInput = ({ placeholder, onBlur, onChange, onPaste, value, ...restProps }) => {
	const handleBlur = (e) => {
		if (e.target.value !== value) onChange?.(e);
		onBlur?.(e);
	};
	const handlePaste = (e) => {
		const clipboardData = e.clipboardData.getData("text/plain");
		const parsedData = phoneNumberSchema.safeParse(clipboardData);
		if (parsedData.success) e.clipboardData.setData("text/plain", parsedData.data);
		onPaste?.(e);
	};
	return /* @__PURE__ */ jsx(TextInput, {
		...restProps,
		placeholder: placeholder || PHONE_PLACEHOLDER,
		mask: PHONE_PLACEHOLDER,
		onPaste: handlePaste,
		onBlur: handleBlur,
		onChange,
		value
	});
};

//#endregion
export { PhoneNumberInput };